export default {"src":"/_next/static/media/warrantyUnnumberedSelected.56f11764.svg","height":84,"width":84,"blurWidth":0,"blurHeight":0};